import {useMutation, useQueryClient} from 'react-query'
import {NotificationSetting} from "../../../types";
import {showNotification} from "@mantine/notifications";
import {Check} from "tabler-icons-react";

const onMutateSuccess = (values: NotificationSetting) => {
    showNotification({
        title: 'Notification setting updated',
        icon: <Check/>,
        message: `Notification setting has been updated!`,
    })
}

const onMutateError = (error: string) => {
    showNotification({
        title: `Something went wrong`,
        message: `An error occurred while updating the notification setting. ${error}`,
        color: 'red'
    })
}

export default function useMutateNotificationSettingData(mutationFn: (args: any) => Promise<unknown>, onSuccess: any = onMutateSuccess, onError: any = onMutateError) {
    const queryClient = useQueryClient();
    return useMutation(mutationFn, {
        onSuccess: (data) => {
            // Reload notification settings data
            queryClient.invalidateQueries(['notificationSettings']);

            onSuccess?.(data)
        },
        onError: (data) => onError?.(data)
    });
}
